// Central content for Club Atletico Bologna (CAB)
// Placeholder realistic data — easily editable by the club.

export const CLUB = {
  name: "Club Atletico Bologna",
  short: "CAB",
  founded: "1948",
  tagline: "Lotta Greco-Romana & Pesistica dal 1948",
  president: "Paolo Landuzzi",
  email: "club.atleticobologna@libero.it",
  pec: "cab.atleticobologna@pec-legal.it",
  phone: "389 119 3245",
  phoneHref: "tel:+393891193245",
  whatsapp: "+39 335 848 3777",
  whatsappHref: "https://wa.me/393358483777",
  address: "Via Aristotile Fioravanti 22",
  city: "40129 Bologna (BO) · Piazza Lucio Dalla",
  addressFull: "Via Aristotile Fioravanti 22, 40129 Bologna (BO)",
  mapsQuery: "Via Aristotile Fioravanti 22, Bologna",
  instagram: "https://www.instagram.com/clubatleticobologna?igsh=dXV1bXY1M3NpN3Jm",
  facebook: "https://www.facebook.com/groups/124684617574515/?ref=ts&fref=ts",
  hours: [
    { day: "Lunedì - Venerdì", time: "16:30 - 22:00" },
    { day: "Sabato", time: "Chiuso" },
    { day: "Domenica", time: "Chiuso" },
  ],
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Chi siamo", to: "/chi-siamo" },
  { label: "Corsi", to: "/corsi" },
  { label: "Medagliere", to: "/medagliere" },
  { label: "Statuto e Bilancio", to: "/statuto-bilancio" },
  { label: "Social", to: "/social" },
  { label: "Dove siamo", to: "/dove-siamo" },
];

const U = "https://images.unsplash.com/";
const q = "?auto=format&fit=crop&q=80";
export const IMAGES = {
  heroWrestling: `${U}photo-1736723212593-2183d03535df${q}&w=2000`,
  heroLifting: `${U}photo-1709315847224-6c8a812e886a${q}&w=2000`,
  gym: "/images/uploads/piazza.webp",
  heritage: `${U}photo-1576570913166-405baebcb76e${q}&w=1600`,
  wrestlingAction: `${U}photo-1657672825833-7b2ad6fae220${q}&w=1600`,
  liftingClose: `${U}photo-1620188526357-ff08e03da266${q}&w=1600`,
  // cropped variants for galleries
  wrestlingTall: `${U}photo-1736723212593-2183d03535df${q}&w=1000&h=1300`,
  wrestlingWide: `${U}photo-1657672825833-7b2ad6fae220${q}&w=1400&h=900`,
  liftingTall: `${U}photo-1709315847224-6c8a812e886a${q}&w=1000&h=1300`,
  liftingWide: `${U}photo-1620188526357-ff08e03da266${q}&w=1400&h=900`,
  gymTall: "/images/uploads/piazza.webp",
  heritageWide: `${U}photo-1576570913166-405baebcb76e${q}&w=1400&h=900`,
  // Foto reali del club (fornite dall'utente)
  squadraRighi: "/images/squadra-lotta-cab-liceo-righi.jpg",
  corsiLotta: "/images/corsi-lotta-greco-romana.jpg",
  squadraPremiata: "/images/squadra-premiata-cab.jpg",
  // Uploads recenti (immagini fornite dall'utente)
  chiSiamoBg: "/images/uploads/99401.jpg",
  corsiCard: "/images/uploads/corsifoto.jpg",
  medagliereBg: "/images/uploads/100359.webp",
  statutoBg: "/images/uploads/statuto.jpg",
  socialBg: "/images/uploads/100360.jpg",
  newsSquadraRighi: "/images/uploads/squadra-righi.jpg",
  bjjNew: "/images/uploads/bjj.jpeg",
  grapplingNew: "/images/uploads/G.jpeg",
  difNew: "/images/uploads/dif.webp",
  ginNew: "/images/uploads/gin.jpg",
  bjjStory: "/images/uploads/NB.jpeg",
  grapplingStory: "/images/uploads/GB.jpeg",
};

export const OVERVIEW = [
  {
    n: "01",
    title: "Chi siamo",
    to: "/chi-siamo",
    image: IMAGES.squadraPremiata,
    text: "Dai '3 moschettieri della lotta' degli anni '30 alla Stella d'Oro CONI: una tradizione che ha reso Bologna capitale della lotta greco-romana.",
  },
  {
    n: "02",
    title: "Corsi",
    to: "/corsi",
    image: IMAGES.corsiCard,
    text: "Lotta, pesistica e powerlifting, BJJ, grappling, difesa personale e ginnastica posturale: un percorso per ogni età e obiettivo.",
  },
  {
    n: "03",
    title: "Medagliere",
    to: "/medagliere",
    image: IMAGES.medagliereBg,
    text: "Oltre 70 anni di podi: dal bronzo olimpico di Fantoni nel 1948 ai titoli mondiali master di oggi. Il nostro palmares completo.",
  },
  {
    n: "04",
    title: "Statuto e Bilancio",
    to: "/statuto-bilancio",
    image: IMAGES.statutoBg,
    text: "Trasparenza prima di tutto. Consulta e scarica lo Statuto, i bilanci annuali e i documenti ufficiali dell'associazione.",
  },
  {
    n: "05",
    title: "Social",
    to: "/social",
    image: IMAGES.socialBg,
    text: "Vivi il club ogni giorno. Seguici su Instagram e Facebook e resta aggiornato su gare, eventi e vita in palestra.",
  },
  {
    n: "06",
    title: "Dove siamo",
    to: "/dove-siamo",
    image: IMAGES.gymTall,
    text: "Ci trovi in via Aristotile Fioravanti 22, presso Piazza Lucio Dalla, nel cuore di Bologna. Orari, contatti e mappa per la tua prova gratuita.",
  },
];

export const VALUES = [
  {
    n: "01",
    title: "Comunità",
    text: "Una palestra nel cuore di Bologna aperta a tutti, dai più giovani ai rappresentanti della terza età. Prima della medaglia, viene la squadra.",
  },
  {
    n: "02",
    title: "Inclusione",
    text: "Lo sport come strumento di crescita e inclusione sociale: al CAB c'è posto per ogni storia, ogni età e ogni obiettivo.",
  },
  {
    n: "03",
    title: "Tradizione",
    text: "Custodiamo la storia che ha reso Bologna capitale della lotta greco-romana e la portiamo avanti con orgoglio, sotto la stessa bandiera dal 1948.",
  },
  {
    n: "04",
    title: "Eccellenza",
    text: "Eccellenza tecnica riconosciuta da CONI, FIJLKAM e AICS: dal bronzo olimpico del 1948 ai titoli mondiali master dei nostri giorni.",
  },
];

export const SEDI = [
  { era: "Le origini", place: "Palestra del Liceo Righi", text: "I primi allenamenti del club prendono forma tra le mura di una delle scuole storiche della città." },
  { era: "Dopoguerra", place: "Ex Forno del Pane — via Rosselli", text: "Il CAB trova casa negli spazi dell'ex Forno del Pane, nel cuore pulsante di Bologna." },
  { era: "Corticella", place: "Caserme Rosse", text: "L'attività prosegue nelle Caserme Rosse a Corticella, tra tatami e pedane sempre affollati." },
  { era: "La Dozza", place: "Centro sportivo della Dozza", text: "Una nuova tappa nel percorso del club, con spazi dedicati alla lotta e al sollevamento pesi." },
  { era: "Oggi", place: "Via Fioravanti 22 — Piazza Lucio Dalla", text: "La sede attuale, nel cuore di Bologna accanto a Piazza Lucio Dalla: una casa per atleti e appassionati di ogni età.", current: true },
];

export const ORIGINI = [
  "Il Club Atletico Bologna rappresenta la continuità di quegli atleti che, prima della guerra, fecero conoscere Bologna come la capitale della Lotta Greco-Romana, quando il Teatro Duse registrava il tutto esaurito con gli incontri della nazionale, composta per la maggior parte da lottatori bolognesi. Negli anni '30, sotto le due torri, avevamo atleti come Malossi, Gruppioni e Donati, definiti i '3 moschettieri della lotta'.",
  "Nel 1948, da una divisione con la Sempre Avanti!, nasce ufficialmente il Club Atletico Bologna, che dichiara base essenziale del suo statuto la diffusione della lotta greco-romana e del sollevamento pesi. Subito, alle Olimpiadi di Londra del 1948, il CAB conquista una storica medaglia di bronzo con il peso massimo Guido Fantoni.",
  "Nel 2014 il CONI ha conferito al CAB la Stella d'Oro al Merito Sportivo e, dal 2018, la presidenza è guidata da Paolo Landuzzi, che ha raccolto il testimone da Angelo Berselli.",
];

export const ANECDOTE = {
  eyebrow: "Lo sapevi che?",
  title: "Gli atleti del CAB a difesa del sindaco",
  text: "Il legame tra il CAB e la città è indissolubile. Nel dopoguerra, quando il sindaco Dozza fu minacciato dagli oppositori durante un volantinaggio in centro, furono proprio gli atleti del CAB a intervenire, formando una ronda attorno al banchetto di propaganda per dargli man forte.",
};

export const PRESIDENZA = {
  president: "Paolo Landuzzi",
  role: "Presidente dal 2018",
  note: "Ha raccolto il testimone da Angelo Berselli, riportando il club tra le realtà più solide e competitive del panorama nazionale.",
};

export const STAFF = [
  {
    settore: "Settore Lotta",
    members: [
      {
        name: "Paolo Landuzzi",
        role: "Tecnico titolare settore Lotta FIJLKAM",
        quals: [
          "Istruttore nazionale lotta olimpica AICS",
          "Allenatore grappling",
          "Maestro di M.G.A. difesa personale FIJLKAM",
          "Istruttore tecnico paralimpico FIS-DIR Lotta FIJLKAM",
          "Diploma nazionale Operatore sportivo per la disabilità AICS",
        ],
      },
      {
        name: "Alessandro Zappalà",
        role: "Allenatore FIJLKAM · resp. settore Lotta",
        quals: [
          "Istruttore nazionale lotta olimpica AICS",
          "Allenatore grappling",
          "Abilitazione KMA difesa personale",
        ],
      },
      {
        name: "Roberto Marchesini",
        role: "Allenatore FIJLKAM · resp. settore Lotta giovanile",
        quals: ["Istruttore nazionale lotta olimpica AICS"],
      },
      { name: "Giovanni Mangione", role: "Asp. allenatore settore Lotta", quals: [] },
      { name: "Luca Benecchi", role: "Asp. allenatore settore Lotta", quals: [] },
    ],
  },
  {
    settore: "Settore Pesi",
    members: [
      {
        name: "Franco Cocchi",
        role: "Tecnico titolare settore Pesi",
        quals: ["Maestro di sollevamento pesi FIPE"],
      },
      { name: "Riccardo Scalorbi", role: "Allenatore FIPE · resp. settore Pesi", quals: [] },
    ],
  },
];

export const RICONOSCIMENTI = [
  { title: "Stella d'Oro al Merito Sportivo", org: "CONI", year: "2014" },
  { title: "Stella d'Argento al Merito Sportivo", org: "CONI", year: "" },
];

export const HONORS = [
  { value: "1948", label: "Bronzo Olimpico · Londra" },
  { value: "2014", label: "Stella d'Oro al Merito CONI" },
  { value: "76+", label: "Anni di storia sportiva" },
  { value: "5", label: "Discipline a medaglia" },
];

export const MEDAGLIERE = {
  intro:
    "Oltre settant'anni di passione, sacrificio e risultati di prestigio nazionale e internazionale. Il medagliere del CAB non è solo un elenco di titoli, ma la testimonianza di educazione sportiva e continuità generazionale, sotto la stessa bandiera.",
  disciplines: [
    {
      name: "Lotta Greco-Romana & Stile Libero",
      tag: "Cuore storico e identitario",
      champions: [
        "Guido Fantoni — Bronzo Olimpico, Londra 1948 · Bronzo Mondiale 1951",
        "Giuseppe Pirazzoli — Oro Giochi del Mediterraneo 1955",
        "Dimitru Popov — Campione Mondiale Master G.R. (2018–2023)",
        "Alessandro Zappala — Vice Campione del Mondo Master 2025",
        "Claudio Evangelisti — Campione Italiano Master G.R. 2024–2025",
      ],
    },
    {
      name: "Sollevamento Pesi / Pesistica",
      tag: "Forza e metodo",
      champions: [
        "Maurizio Bombacci — 10 volte Campione Italiano Assoluto (1993–2012)",
        "Maurizio Bombacci — Campione Mondiale Master 2014",
        "Enrico Majerna e Luca Parlascino — Oro Italiani Universitari 2025",
      ],
    },
    {
      name: "BJJ / Grappling",
      tag: "La tradizione si evolve",
      champions: [
        "Martina Baraccani — Campionessa del Mondo BJJ 2013",
        "Stefano Raspadori — Campione del Mondo Veterani 2010",
      ],
    },
    {
      name: "Titoli di Squadra",
      tag: "Spirito di gruppo",
      champions: [
        "1ª Classificata Trofeo Bologna 2025–2026",
        "1ª Classificata Open Italia 2025",
        "Vincitrice Coppa Italia Senior 2023–2025",
        "Campione d'Italia Master Greco-Romana 2022",
      ],
    },
  ],
};

export const NEWS = {
  eyebrow: "News · Evento",
  date: "76° Anniversario",
  title: "Il CAB celebra 76 anni di storia sportiva e sociale",
  image: IMAGES.newsSquadraRighi,
  body: [
    "Una bella pagina di storia sportiva bolognese è stata celebrata al circolo Arci Ippodromo in occasione del 76° anniversario del CAB, con ospiti d'eccezione che hanno ripercorso le glorie presenti e passate del club.",
    "A fare da cerimoniere, nell'intervallo tra tagliatelle e crescentine, è stato il Presidente CAB Paolo Landuzzi, che ha premiato atleti e vecchi soci ed esposto l'attuale situazione societaria.",
    "È intervenuta l'assessora allo sport Roberta Li Calzi, che ha rassicurato sul proseguimento dell'attività nella sede comunale attuale di via Fioravanti 22 almeno fino al termine della stagione sportiva.",
    "Presente il consigliere comunale Claudio Mazzanti, che ha ricordato le sfide e il fratello campione di lotta al CAB, ed esponenti di spicco delle federazioni tra cui il presidente federale Lotta Giovanni Morsiani e il presidente FIPE Emilia Romagna Matteo Raspadori, accompagnato dall'icona del sollevamento pesi bolognese, il maestro Franco Cocchi.",
  ],
};

export const DOCUMENTS = [
  {
    title: "Statuto del Club",
    subtitle: "Aggiornamento Novembre 2023",
    category: "Statuto",
    year: "2023",
    size: "0,5 MB",
    file: "/documents/statuto-aggiornato-2023.pdf",
    desc: "Il documento che regola la vita associativa del club: finalità, organi, diritti e doveri dei soci.",
  },
  {
    title: "Bilancio Annuale",
    subtitle: "Esercizio 2025",
    category: "Bilancio",
    year: "2025",
    size: "0,4 MB",
    file: "/documents/bilancio-2025.pdf",
    desc: "Il rendiconto economico e finanziario dell'associazione, a garanzia della piena trasparenza verso i soci.",
  },
  {
    title: "Atto Costitutivo + Primo Statuto",
    subtitle: "Documento storico 1948",
    category: "Storico",
    year: "1948",
    size: "2,6 MB",
    file: "/documents/atto-costitutivo-statuto-1948.pdf",
    desc: "Le origini del CAB: l'atto costitutivo rigenerato e il primo storico statuto della fondazione del 1948.",
  },
  {
    title: "Dichiarazione Contributi",
    subtitle: "Registro 2024",
    category: "Trasparenza",
    year: "2024",
    size: "0,2 MB",
    file: "/documents/dichiarazione-contributi-2024.pdf",
    desc: "Dichiarazione relativa ai contributi pubblici ricevuti, come previsto dagli obblighi di trasparenza.",
  },
];

export const LOTTA = {
  hero: IMAGES.heroWrestling,
  intro:
    "Cuore storico e identitario del Club: dalle Olimpiadi del dopoguerra fino ai titoli mondiali master del nuovo millennio, una tradizione tecnica e morale riconosciuta a livello nazionale.",
  benefits: [
    { title: "Forza funzionale", text: "Sviluppa potenza, esplosività e controllo del corpo in ogni movimento." },
    { title: "Autocontrollo", text: "Insegna a gestire emozioni e reazioni sotto pressione, sul tatami e nella vita." },
    { title: "Coordinazione", text: "Migliora equilibrio, agilità e consapevolezza spaziale a ogni livello." },
    { title: "Rispetto", text: "Il codice della lotta mette al centro l'avversario, l'arbitro e le regole." },
  ],
  schedule: [
    { group: "Bambini", days: "Lunedì · Mercoledì · Venerdì", time: "17:15 - 18:15" },
    { group: "Adulti", days: "Lunedì · Mercoledì", time: "18:15 - 19:45" },
    { group: "Adulti", days: "Venerdì", time: "18:15 - 20:00" },
  ],
  coaches: [
    { name: "Paolo Landuzzi", role: "Tecnico titolare settore Lotta FIJLKAM" },
    { name: "Alessandro Zappalà", role: "Allenatore FIJLKAM · resp. settore Lotta" },
    { name: "Roberto Marchesini", role: "Allenatore FIJLKAM · settore giovanile" },
  ],
  gallery: ["/images/uploads/lotta-1.webp", "/images/uploads/lotta-2.webp", "/images/uploads/lotta-3-new.png"],
};

export const PESISTICA = {
  hero: IMAGES.heroLifting,
  intro:
    "Dal sollevamento pesi olimpico al powerlifting, dal biathlon alla distensione su panca: una tradizione di campioni italiani e mondiali, da Maurizio Bombacci ai nostri giovani universitari. La sala pesi del CAB è uno spazio dove tecnica e forza si costruiscono con metodo e sicurezza.",
  equipment: [
    { title: "Pedane olimpiche", text: "Zone dedicate a strappo e slancio con bilancieri e dischi bumper professionali." },
    { title: "Sala pesi completa", text: "Rack, panche, manubri e macchinari per la forza e l'ipertrofia." },
    { title: "Area funzionale", text: "Kettlebell, palle mediche e spazio per mobilità e condizionamento." },
    { title: "Recupero", text: "Zona stretching e strumenti per la prevenzione degli infortuni." },
  ],
  programs: [
    { title: "Pesistica olimpica", text: "Tecnica di strappo e slancio seguiti da preparatori qualificati, per agonisti e principianti." },
    { title: "Forza & Condizionamento", text: "Programmi di forza personalizzati per atleti di altre discipline e appassionati." },
    { title: "Allenamento libero", text: "Sala pesi accessibile negli orari di apertura con supervisione dello staff tecnico." },
  ],
  schedule: [
    { group: "Sollevamento pesi · Bambini e Adulti", days: "Lunedì - Venerdì", time: "17:30 - 21:00" },
  ],
  coaches: [
    { name: "Staff Tecnico FIPE", role: "Preparatori di sollevamento pesi e forza" },
    { name: "Preparazione Atletica", role: "Programmi personalizzati e allenamento libero seguito" },
  ],
  gallery: [IMAGES.liftingTall, IMAGES.liftingWide, IMAGES.gym, IMAGES.liftingClose],
};

export const LOTTA_STORY = {
  eyebrow: "Cuore storico e identitario del Club",
  paragraphs: [
    "Dalle Olimpiadi del dopoguerra fino ai titoli mondiali master del nuovo millennio, la sezione lotta del C.A.B. ha espresso campioni olimpici, atleti azzurri, pluricampioni italiani e mondiali, costruendo una tradizione tecnica e morale riconosciuta a livello nazionale.",
    "Spiccano figure leggendarie come Guido Fantoni, atleta di valore mondiale, bronzo olimpico a Londra 1948, e Giuseppe Pirazzoli, oro ai Giochi del Mediterraneo. Seguono generazioni di campioni italiani assoluti, universitari, junior, master e giovanili che hanno portato il nome del Club sui podi per decenni.",
    "Negli anni più recenti, atleti come Popov Dimitru, Zappalà Alessandro, Claudio Evangelisti e Giovanni Mangione hanno confermato la vitalità del settore con titoli mondiali, italiani e universitari, mantenendo viva la tradizione agonistica del C.A.B.",
  ],
};

export const LOTTA_TITOLI = {
  intro:
    "Il valore del Club non si misura solo nei successi individuali, ma anche nei risultati collettivi, frutto di spirito di squadra, organizzazione e continuità tecnica:",
  items: [
    "Campione d'Italia Master Greco-Romana",
    "Vincitore Coppa Italia Senior",
    "1ª classificata Open Italia Torino 2025",
    "1ª classificata Trofeo Bologna 2025 / 2026",
  ],
  closing:
    "Risultati che confermano come il Club Atletico Bologna, grazie alla tenacia dell'attuale presidente Paolo Landuzzi, sia tornato competitivo, segnalandosi tra le realtà più solide e competitive del panorama nazionale.",
};

export const PATRIMONIO = {
  title: "Un patrimonio sportivo e umano",
  intro:
    "Il Medagliere del Club Atletico Bologna non è solo un elenco di titoli, ma la testimonianza concreta di:",
  values: [
    "Educazione sportiva",
    "Continuità generazionale",
    "Attaccamento ai valori dello sport",
    "Eccellenza tecnica riconosciuta dal CONI, FIJLKAM e AICS",
  ],
  closing:
    "Una storia che continua, sotto la stessa bandiera, con lo sguardo rivolto al futuro e il rispetto profondo per il passato.",
};

export const PESISTICA_BIATHLON = {
  eyebrow: "Discipline di forza pura",
  title: "Biathlon e distensione su panca",
  text: "Anche nelle discipline multidisciplinari e di forza pura, il Club ha saputo esprimere campioni italiani senior, junior e universitari, contribuendo a rendere il medagliere del C.A.B. ampio, trasversale e unico nel suo genere.",
};

export const SOCIAL_POSTS = [
  { image: IMAGES.wrestlingWide, caption: "1ª classificata all'Open Italia 2025 di lotta #CAB1948", tag: "Gare" },
  { image: IMAGES.liftingWide, caption: "Oro agli Italiani Universitari di pesistica 2025", tag: "Pesistica" },
  { image: IMAGES.gymTall, caption: "La nostra casa in via Fioravanti: tatami e pedane pronti", tag: "Palestra" },
  { image: IMAGES.wrestlingTall, caption: "Settore giovanile: si cresce insieme, dal 1948", tag: "Giovani" },
  { image: IMAGES.liftingTall, caption: "Tecnica di strappo e slancio in sala pesi", tag: "Tecnica" },
  { image: IMAGES.heritageWide, caption: "76 anni di storia: dal Teatro Duse a oggi", tag: "Storia" },
];

// Orari settimanali completi per tutti i corsi
export const ORARI_CORSI = [
  {
    id: "lotta",
    title: "Lotta Greco-Romana e Libera",
    color: "cab",
    slots: [
      { group: "Bambini", days: "Lunedì · Mercoledì · Venerdì", time: "17:15 - 18:15" },
      { group: "Adulti", days: "Lunedì · Mercoledì", time: "18:15 - 19:45" },
      { group: "Adulti", days: "Venerdì", time: "18:15 - 20:00" },
    ],
  },
  {
    id: "pesistica",
    title: "Pesistica e Powerlifting",
    color: "cab",
    slots: [
      { group: "Sollevamento pesi · Bambini e Adulti", days: "Lunedì - Venerdì", time: "17:30 - 21:00" },
    ],
  },
  {
    id: "bjj-grappling",
    title: "Grappling e BJJ",
    color: "cab",
    note: "Stessi orari per Grappling e Brazilian Jiu-Jitsu",
    slots: [
      { group: "Serale", days: "Lunedì · Mercoledì", time: "19:45 - 21:00" },
      { group: "Pausa pranzo", days: "Martedì · Giovedì", time: "13:30 - 14:30" },
      { group: "Serale", days: "Martedì · Giovedì", time: "19:30 - 21:30" },
      { group: "Serale", days: "Venerdì", time: "20:00 - 21:30" },
    ],
  },
  {
    id: "ginnastica-posturale",
    title: "Ginnastica posturale",
    color: "cab",
    slots: [
      { group: "Mattina", days: "Martedì · Giovedì", time: "8:30 - 9:30 · 9:30 - 10:30" },
      { group: "Pomeriggio", days: "Martedì · Giovedì", time: "18:30 - 19:30" },
    ],
  },
  {
    id: "difesa-personale",
    title: "Difesa personale",
    color: "cab",
    slots: [
      { group: "Adulti", days: "Martedì", time: "17:15 - 18:30" },
      { group: "Adulti", days: "Sabato", time: "16:00 - 17:30" },
    ],
  },
];

export const ORARI_PROMO = {
  eyebrow: "Vantaggi per i nuovi iscritti",
  items: [
    "Bambini sotto i 12 anni: un mese di prova omaggio",
    "Prove gratuite per tutti i corsi, in qualsiasi periodo dell'anno",
  ],
};

// Nuove discipline con pagina dedicata (BJJ, Grappling, Difesa personale, Ginnastica posturale)
export const DISCIPLINES = {
  bjj: {
    slug: "bjj",
    hero: IMAGES.bjjNew,
    overline: "Brazilian Jiu-Jitsu",
    titleLines: ["Il", "BJJ"],
    intro:
      "L'arte marziale della sottomissione: strategia, leve e controllo a terra. Al CAB, il Brazilian Jiu-Jitsu si allena come al piano di sopra della lotta greco-romana — con lo stesso rigore tecnico che ci ha regalato titoli mondiali.",
    story: {
      eyebrow: "Una tradizione che si evolve",
      title: "Dalla lotta al BJJ, sotto la stessa bandiera",
      image: IMAGES.bjjStory,
      paragraphs: [
        "Il Brazilian Jiu-Jitsu è entrato al Club Atletico Bologna come naturale evoluzione della cultura della lotta a terra che caratterizza il CAB da sempre. Grazie all'esperienza tecnica dei nostri istruttori — con abilitazioni FIJLKAM/grappling e KMA — offriamo un percorso completo che unisce basi tradizionali e metodologia moderna.",
        "Il BJJ del CAB ha già scritto pagine importanti: Martina Baraccani campionessa italiana 2014 con partecipazioni ai Mondiali Senior BJJ e No-Gi 2013 in Canada e agli Europei FILA 2013 in Polonia; Stefano Raspadori campione del Mondo Veterani 2010 in Croazia e campione italiano assoluto 2011 a Ostia.",
        "Che tu sia principiante o cintura avanzata, troverai un ambiente serio, tecnico e inclusivo, dove la sottomissione è prima di tutto un esercizio di pazienza, controllo e rispetto dell'avversario.",
      ],
    },
    benefits: [
      { title: "Tecnica pura", text: "Leve, prese e controllo posizionale: il BJJ è scacchi in movimento, per costruire un pensiero tattico sotto pressione." },
      { title: "Difesa personale", text: "Un'arte marziale efficace nella realtà: gestire chi è più forte con leva, timing e posizione." },
      { title: "Forma fisica", text: "Un allenamento totale che sviluppa mobilità, cardio, forza isometrica e resistenza mentale." },
      { title: "Comunità", text: "Il tatami come luogo di crescita: si allena in coppia, si progredisce insieme, cintura dopo cintura." },
    ],
    coaches: [
      { name: "Paolo Landuzzi", role: "Allenatore grappling · Maestro M.G.A. FIJLKAM" },
      { name: "Alessandro Zappalà", role: "Allenatore grappling · Istruttore lotta olimpica AICS" },
    ],
    galleryKeys: [],
    marquee: ["Tecnica", "Controllo", "Pazienza", "Rispetto"],
  },
  grappling: {
    slug: "grappling",
    hero: IMAGES.grapplingNew,
    overline: "Grappling · Lotta senza gi",
    titleLines: ["Il", "Grappling"],
    intro:
      "Prese, proiezioni, sottomissioni: il grappling unisce il meglio della lotta olimpica, del jiu-jitsu e del sambo in una disciplina dinamica, moderna e accessibile a tutti i livelli.",
    story: {
      eyebrow: "L'anima moderna della lotta",
      title: "Un allenamento completo, senza kimono",
      image: IMAGES.grapplingStory,
      paragraphs: [
        "Il grappling è una disciplina no-gi che integra le tecniche di lotta in piedi (proiezioni, prese, atterramenti) con la lotta a terra (controlli, transizioni, sottomissioni). Al Club Atletico Bologna si allena con la stessa metodologia della lotta olimpica: fondamentali, ripetizione tecnica, situazioni e sparring controllato.",
        "L'approccio del CAB è tecnico prima che agonistico: si costruisce un lottatore completo, capace di gestire ogni distanza — dal contatto in piedi al ground game. Uno stile ideale sia per chi si prepara a competere in circuiti ADCC/FILA sia per chi cerca un'attività di forza e coordinazione senza traumi.",
        "Grappling e BJJ condividono gli stessi orari e in parte gli stessi tatami: due discipline complementari, un'unica cultura del rispetto e della crescita.",
      ],
    },
    benefits: [
      { title: "Completezza", text: "In piedi e a terra, prese e sottomissioni: nessuna dimensione della lotta rimane fuori dal programma." },
      { title: "Adattabilità", text: "Un allenamento graduabile, adatto sia agli agonisti sia agli amatori che vogliono restare in forma." },
      { title: "Sicurezza", text: "Progressioni tecniche graduate, sparring guidato e attenzione costante alla prevenzione infortuni." },
      { title: "Trasversalità", text: "Ideale come cross-training per lottatori, judoka, MMA fighter, praticanti di BJJ e sport da combattimento." },
    ],
    coaches: [
      { name: "Paolo Landuzzi", role: "Allenatore grappling · Istruttore nazionale lotta AICS" },
      { name: "Alessandro Zappalà", role: "Allenatore grappling · Resp. settore Lotta" },
    ],
    galleryKeys: [],
    marquee: ["Prese", "Proiezioni", "Sottomissioni", "Controllo"],
  },
  "difesa-personale": {
    slug: "difesa-personale",
    hero: IMAGES.difNew,
    overline: "M.G.A. FIJLKAM · Metodo Globale Autodifesa",
    titleLines: ["Difesa", "personale"],
    intro:
      "Il Metodo Globale Autodifesa FIJLKAM: tecniche pratiche, consapevolezza situazionale e gestione dello stress. Un percorso strutturato pensato per adulti di ogni età e livello, con un maestro certificato FIJLKAM.",
    story: {
      eyebrow: "Sicurezza personale con metodo",
      title: "Non uno sport da combattimento, uno strumento di consapevolezza",
      image: "/DP.webp",
      paragraphs: [
        "Il M.G.A. — Metodo Globale Autodifesa — è il sistema ufficiale FIJLKAM di difesa personale, riconosciuto a livello nazionale e adottato anche da forze dell'ordine e istruttori militari. Non è un'arte marziale sportiva, ma un percorso di educazione alla sicurezza personale che integra tecniche di judo, karate e lotta con nozioni di prevenzione, gestione emotiva e legittima difesa.",
        "Al Club Atletico Bologna il corso è guidato da Paolo Landuzzi, Maestro M.G.A. FIJLKAM e Istruttore tecnico paralimpico FIS-DIR, con qualifica di Diploma nazionale Operatore sportivo per la disabilità AICS. Un approccio inclusivo e adatto anche a persone con esigenze specifiche.",
        "Il programma è strutturato su tecniche semplici, replicabili sotto stress, allenamento della postura e della prontezza — senza rischi da sport da combattimento e senza necessità di preparazione fisica preliminare.",
      ],
    },
    benefits: [
      { title: "Efficacia reale", text: "Tecniche selezionate per funzionare nella realtà: leve, atterramenti, disimpegni, uscite da situazioni pericolose." },
      { title: "Consapevolezza", text: "Prevenzione, lettura dell'ambiente e gestione del linguaggio del corpo: la difesa comincia molto prima del contatto." },
      { title: "Inclusività", text: "Un corso per tutti: uomini, donne, giovani e adulti. Nessun prerequisito fisico o marziale richiesto." },
      { title: "Certificazione", text: "Programma FIJLKAM ufficiale, con istruttore Maestro certificato. Possibilità di percorsi di formazione." },
    ],
    coaches: [
      { name: "Paolo Landuzzi", role: "Maestro M.G.A. difesa personale FIJLKAM" },
      { name: "Alessandro Zappalà", role: "Abilitazione KMA difesa personale" },
    ],
    galleryKeys: [],
    marquee: ["Prevenzione", "Consapevolezza", "Tecnica", "Sicurezza"],
  },
  "ginnastica-posturale": {
    slug: "ginnastica-posturale",
    hero: IMAGES.ginNew,
    overline: "Mobilità · Benessere · Postura",
    titleLines: ["Ginnastica", "posturale"],
    intro:
      "Un percorso dolce, guidato e progressivo per riequilibrare la postura, prevenire i dolori muscolo-scheletrici e ritrovare energia. Ideale per chi passa molte ore alla scrivania, per gli sportivi in fase di recupero e per adulti di ogni età.",
    story: {
      eyebrow: "La palestra come cura di sé",
      title: "Il benessere quotidiano, un allenamento alla volta",
      image: "/GIPO.jpg",
      paragraphs: [
        "La ginnastica posturale del Club Atletico Bologna è pensata per chi cerca un'attività fisica misurata, tecnica e realmente efficace sui dolori cronici legati alla vita sedentaria: cervicale, lombalgia, tensioni alle spalle, sciatalgia.",
        "Le lezioni combinano mobilità articolare, rinforzo del core, allungamento globale decompensato, respirazione e propriocezione. Non è pilates puro e non è yoga: è un metodo integrato costruito sull'esperienza sportiva del CAB, che unisce la cultura della biomeccanica della lotta e del sollevamento pesi con l'attenzione alla salute quotidiana.",
        "I gruppi sono piccoli, seguiti individualmente e adatti a persone di tutte le età. Puoi allenarti al mattino o nel pomeriggio, con orari pensati anche per chi lavora.",
      ],
    },
    benefits: [
      { title: "Antidolorifico naturale", text: "Riduce cervicale, lombalgia e tensioni: un'ora di posturale vale quanto un massaggio, ma con effetti duraturi." },
      { title: "Mobilità articolare", text: "Recuperi range di movimento persi nel tempo e prevenzione degli infortuni sul lavoro e nello sport." },
      { title: "Core & respirazione", text: "Rinforzi la muscolatura profonda e impari a respirare in modo funzionale, migliorando anche postura ed energia." },
      { title: "Su misura", text: "Lezioni in piccoli gruppi con adattamenti individuali. Adatto a over 60, sedentari, sportivi in recupero." },
    ],
    coaches: [
      { name: "Staff tecnico CAB", role: "Preparatori esperti in ginnastica correttiva e mobilità" },
    ],
    galleryKeys: [],
    marquee: ["Postura", "Mobilità", "Respirazione", "Benessere"],
  },
};

// Build a mailto link with a pre-filled subject/body
export const mailto = (subject, body) =>
  `mailto:${CLUB.email}?subject=${encodeURIComponent(subject || "")}${
    body ? `&body=${encodeURIComponent(body)}` : ""
  }`;

// Gmail compose deep link (opens Gmail in browser)
export const gmailCompose = (subject, body) =>
  `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(CLUB.email)}&su=${encodeURIComponent(
    subject || ""
  )}&body=${encodeURIComponent(body || "")}`;
